export const calculatePaginationOffset = (page: number, perPage: number) =>
  perPage * (page - 1);
